import { render, staticRenderFns } from "./TVERendezvousProviders.vue?vue&type=template&id=503217ee"
import script from "./TVERendezvousProviders.vue?vue&type=script&lang=js"
export * from "./TVERendezvousProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.12.17__css-loader@3.6.0_webp_2d0e0eb1a61523d350544b0b85a86a62/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports